import { render, staticRenderFns } from "./MetaInsights.vue?vue&type=template&id=1d0c299b&scoped=true"
import script from "./MetaInsights.vue?vue&type=script&lang=js"
export * from "./MetaInsights.vue?vue&type=script&lang=js"
import style0 from "./MetaInsights.vue?vue&type=style&index=0&id=1d0c299b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d0c299b",
  null
  
)

export default component.exports